import script from "./DivCell.vue?vue&type=script&setup=true&lang=js"
export * from "./DivCell.vue?vue&type=script&setup=true&lang=js"

import "./DivCell.vue?vue&type=style&index=0&id=04afbc5b&lang=css"

const __exports__ = script;

export default __exports__